import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Template, OptionsListMulti, DocumentTemplatesService, GungNotificationService } from 'gung-common';
import { first } from 'rxjs';
import { GungSettingsApiService } from '../../../services/gung-settings-api.service';

@Component({
    selector: 'lib-api-template-create-modal',
    templateUrl: './api-template-create-modal.component.html',
    styleUrl: './api-template-create-modal.component.scss',
    standalone: false
})
export class ApiTemplateCreateModalComponent implements OnInit {
  templateId: string;
  templateName: string;
  error: any;
  rolesList: OptionsListMulti[];
  availableToRoles: string[] = [];
  selectedTemplate: Template;
  showXlsxAutomatically: boolean;
  baseEntitiesList = [];
  selectedBaseEntity;
  entityName: string;

  constructor(
    protected translateService: TranslateService,
    protected documentTemplatesService: DocumentTemplatesService,
    public activeModal: NgbActiveModal,
    protected router: Router,
    protected apiConfigurationService: GungSettingsApiService,
    protected notificationService: GungNotificationService
  ) {}


  ngOnInit(): void {
    this.availableToRoles = ["ADMIN"];

    this.baseEntitiesList = [
      { id: 'availabilities', name: 'Availabilities', selected: false },
      { id: 'products', name: 'Products', selected: false },
      { id: 'prices', name: 'Prices', selected: false },
      { id: 'deliveries', name: 'Deliveries', selected: false },
      { id: 'customers', name: 'Customers', selected: false },
      { id: 'metadata', name: 'Metadata', selected: false },
      { id: 'categories', name: 'Categories', selected: false },
      { id: 'customerContacts', name: 'Customer Contacts', selected: false },
      { id: 'orders', name: 'Orders', selected: false }
    ];
  }

  /*
  public setSelectedValues(roles): void {
    this.availableToRoles = roles;
  }
  */

  create(): void {
    this.error = null;

    if (!this.templateId) {
      this.error = { message: this.translateService.instant('TEMPLATE_ID_UNDEFINED') };
      return;
    }
    if (!this.templateName) {
      this.error = { message: this.translateService.instant('TEMPLATE_NAME_UNDEFINED') };
      return;
    }
    if (!this.selectedBaseEntity) {
      this.error = { message: this.translateService.instant('ENTITY_REQUIRED') };
      return;
    }
    if (!this.entityName) {
      this.error = { message: this.translateService.instant('ENTITY_NAME_REQUIRED') };
      return;
    }
    this.templateId = this.templateId.replace(' ', '_'); // ID is used for translation tag.
    const documentTemplate: Template = {
      id: this.templateId,
      name: this.templateName,
      availableToRoles: this.availableToRoles,
      showXlsxAutomatically: false,
      type: "API",
      showInApi: true,
      apiBaseEntityName: this.selectedBaseEntity.id,
      apiEntityName: this.entityName,
      headerDefinition: {
        definitionId: null,
        tag: null,
        includeTargetPath: false,
        columns: [],
      },
      lineDefinition: {
        definitionId: null,
        tag: null,
        includeTargetPath: false,
        columns: [],
      },
    };
    this.documentTemplatesService
      .createNewTemplate(documentTemplate)
      .pipe(first())
      .subscribe(
        newTemplate => {

          const additionalEntity = {
            entity: newTemplate.apiEntityName,
            relatedMainEntity: newTemplate.apiBaseEntityName,
          };
          
          this.apiConfigurationService.getApiConfigurations()
            .pipe(first())
            .subscribe(apiConfig => {
              if (apiConfig) {
                if (apiConfig.additionalEntities.findIndex(e => e.entity === newTemplate.apiEntityName) === -1) {
                  apiConfig.additionalEntities.push(additionalEntity);
                  
                  this.apiConfigurationService.saveApiConfigurations(apiConfig)
                    .pipe(first())
                    .subscribe(config => {
                      this.activeModal.close();
                      window.location.reload();
                    });
                }
              } 
            });
        },
        httpErrorResponse => {
          this.error = httpErrorResponse.error;
        }
      );
  }
}
